<!--
 * @Author: guoyu
 * @Date: 2020-09-03 10:42:36
 * @LastEditors: your name
 * @LastEditTime: 2021-04-14 10:55:27
 * @Description: 取消订单
-->
<template>
  <el-dialog
    :style="{
      width: width
    }"
    class="cancel-popup slid-dialog"
    :visible.sync="orderCancelShow"
    append-to-body
    :show-close="false"
  >
    <div class="cancel-title">
      <span>取消訂單</span>
      <fps-icon
        class="close-icon"
        type="close"
        color="#999999"
        @click.native="onCancel"
      />
    </div>
    <div class="reason-list">
      <p class="check-tip">選擇取消原因</p>
      <el-radio
        class="reason-item"
        v-for="(item, index) in columns"
        v-model="reportReason"
        :key="'r' + index"
        :label="item"
        >{{ item }}</el-radio
      >
    </div>
    <div class="popup-footer">
      <div class="submit-button" @click="onConfirm">提交</div>
    </div>
  </el-dialog>
</template>

<script>
import popupMixin from '@/components/common/popup/general.js';
import FpsIcon from '@/components/FpsIcon';
import { cancelOrder, cancelPay } from './order';
export default {
  mixins: [popupMixin],
  components: {
    FpsIcon
  },
  props: {
    width: {
      type: String,
      default:'411px',
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    orderCancelShow: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      reportReason: ''
    };
  },
  computed: {
    columns() {
      return this.orderInfo.status === 'Created'
        ? ['不想下單了', '不小心按到了', '修改訂單訊息再重新下單']
        : [
            '不想下單了',
            '不小心按到了',
            '修改訂單訊息再重新下單',
            '陪玩師沒有回覆',
            '陪玩師目前沒空接單',
            '技能或時間談不攏',
            '陪玩師要求取消'
          ];
    }
  },
  methods: {
    onConfirm() {
      if (!this.reportReason) {
        this.$message.error('請選擇取消原因')
        return
      }
      if (this.cancelloading) return;
      this.cancelloading = true;
      let req = this.orderInfo.status === 'Created' ? cancelPay : cancelOrder;
      req({
        uuid: this.orderInfo.orderNo,
        reportReason: this.reportReason
      })
        .then(() => {
          this.orderInfo.status = 'Invalid';
          this.$store.dispatch('app/getUserInfo');
          this.onCancel()
          this.cancelloading = false;
        })
        .catch(e => {
          console.error(e);
          this.cancelloading = false;
        });
    },
    onCancel() {
      this.$emit('closeDialog', false)
    }
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
.slid-dialog {
  font-size: 16px;
  padding: 0px;
  .slid-title {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 61px;
    padding: 0 20px;
    border-bottom: 1px solid #ECECEC;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 61px;
      color: #000000;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
  .slid-footer {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .confirm-btn, .cancel-btn{
      width: 100px;
      height: 40px;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
    }
    .confirm-btn {
      color: #FFFFFF;
      background: linear-gradient(151.16deg, #FF4417 2.04%, #FB006E 60.91%);
    }
    .cancel-btn {
      background: #FFFFFF;
      color: black;
    }
  }
}
.cancel-popup {
  width: 418px;
  overflow: hidden;
  border-radius: 8px;
  color: #222c43;
}
.cancel-title {
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  border-bottom: 1px solid #ececec;
  font-weight: 500;
  font-size: 18px;
}
.reason-list {
  padding: 20px 18px 0;
  font-size: 14px;
}
.check-tip {
  margin-bottom: 20px;
  font-weight: 500;
  line-height: 1;
}
.reason-item {
  display: block;
  height: 20px;
  margin-bottom: 20px;
  line-height: 20px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  padding-right: 25px;
  border-top: 1px solid #ececec;
}
.submit-button {
  height: 40px;
  width: 100px;
  background: $color-yellow;
  border-radius: 50px;
  text-align: center;
  line-height: 40px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}
.close-icon {
  cursor: pointer;
}
</style>
<style lang="scss">
.el-dialog{
  box-shadow:none;
}
.el-dialog__wrapper.slid-dialog{
  margin: 0 auto;
  .el-dialog{
    width: 100%;
  }
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>
